import originalAxios from 'axios'
import axios from './index'

const prefix = 'driver'

export const read = params => {
  if (typeof params === 'object' || params === undefined) {
    return axios.get(prefix, { params })
  } else {
    return axios.get(`${prefix}/${params}`)
  }
}

export const create = payload => {
  return axios.post(prefix, payload)
}

export const update = payload => {
  return axios.put(prefix, payload)
}

export const del = id => {
  return axios.delete(`${prefix}/${id}`)
}

export const exportDriver = id => {
  const axiosInstance = originalAxios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 10000,
    withCredentials: true,
    headers: { 'App-Name': 'blaze' }
  })
  return axiosInstance.post(`${prefix}/export/${id}`)
}

export const importDriver = payload => {
  return axios.post(`${prefix}/import`, payload)
}
